import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
  YOUTUBE_BROADCASTS_GRID_ITEM_SIZE,
  YOUTUBE_BROADCASTS_GRID_SKELETON_COUNT,
  YOUTUBE_BROADCASTS_GRID_SPACING,
} from './youtube-broadcasts-grid-constants';
import { YoutubeBroadcastCardSkeleton } from '../card/YoutubeBroadcastCardSkeleton';

/** Skeleton grid shown while YouTube broadcasts are loading. */
export function YoutubeBroadcastsGridSkeleton() {
  return (
    <Box>
      <Grid container spacing={YOUTUBE_BROADCASTS_GRID_SPACING} columns={60}>
        {Array.from({ length: YOUTUBE_BROADCASTS_GRID_SKELETON_COUNT }).map((_, i) => (
          <Grid size={YOUTUBE_BROADCASTS_GRID_ITEM_SIZE} key={i}>
            <YoutubeBroadcastCardSkeleton />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
